import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';

import { save } from './api';
import CompanyOfficeRow from './company_office_row';
import EditModal from './edit_modal';

import './styles.scss';

export default class InvoicingForm extends React.Component {
  static propTypes = {
    companyOffices: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
    companyPath: PropTypes.string.isRequired,
  }

  state = {
    companyOffices: this.props.companyOffices,
  }

  handleEdit = (companyOffice) => {
    this.setState({
      editingCompanyOffice: companyOffice,
    });
  }

  handleEditSubmit = (companyOffice) => {
    const companyOffices = this.state.companyOffices.map((office) => {
      if (office.id === companyOffice.id) {
        return companyOffice;
      }

      return {
        ...office,
        nextInvoiceNumber: null,
      };
    });

    return save(this.props.companyPath, companyOffices);
  }

  handleEditSave = (companyOffice) => {
    this.setState(state => ({
      editingCompanyOffice: null,
      companyOffices: state.companyOffices.map(office => (
        office.id === companyOffice.id ?
          { ...companyOffice, nextInvoiceNumber: companyOffice.nextInvoiceNumber || office.nextInvoiceNumber } :
          office
      ))
    }));
  }

  handleEditCancel = () => {
    this.setState({ editingCompanyOffice: null });
  }

  showOfficeName() {
    return this.props.companyOffices.length > 1;
  }

  render() {
    return <React.Fragment>
      {this.renderTable()}
      <EditModal
        companyOffice={this.state.editingCompanyOffice}
        showOfficeName={this.showOfficeName()}
        onCancel={this.handleEditCancel}
        onSave={this.handleEditSave}
        onSubmit={this.handleEditSubmit}
      />
    </React.Fragment>;
  }

  renderTable() {
    const { companyOffices } = this.state;

    return (
      <div className="row">
        <div className="col-xs-12 invoice-settings-index">
          <h3 className="mt-0">Invoice Settings</h3>
          <div className="backoffice-settings-table-wrapper sticky-actions">
            <Table responsive>
              <thead>
                <tr>
                  {this.showOfficeName() && <th name="company-office-header-cell">Office</th>}
                  <th>Invoice Number Prefix</th>
                  <th className="next-number-cell">Next Invoice Number</th>
                  <th className="remit-to-cell">Remit To</th>
                  <th>Notes</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {companyOffices.map(
                  office => (
                    <CompanyOfficeRow
                      companyOffice={office}
                      key={office.id}
                      showOfficeName={this.showOfficeName()}
                      onEdit={this.handleEdit}
                    />
                  )
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}
